export { ThankYouPage } from "./components/ThankYouPage";
